export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '投标网站名称',
            prop: 'websiteName',
            width: 150
        },
        {
            label: '投标网址',
            prop: 'websiteUrl',
            width: 200,
            type: 'slot'
        },
        {
            label: '投标账号类型',
            prop: 'accountType',
            type: 'select',
            optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_TYPE',
            width: 110
        },
        {
            label: '账号',
            prop: 'websiteAccount',
            type: 'slot',
            width: 150
        },
        {
            label: '密码',
            prop: 'accountPassword',
            type: 'slot',
            width: 120
        },
        {
            label: '账号状态',
            prop: 'accountStatus',
            type: 'select',
            optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_STATUS'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 180
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            width: 120
        },
        {
            label: '客户等级',
            prop: 'customerLevel',
            type: 'select',
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 100
        },
        {
            label: '绑定手机号',
            prop: 'registrantPhone',
            width: 100,
            type: 'slot'
        },
        {
            label: '账号绑定人',
            prop: 'accountRegistrant',
            width: 120
        },
        {
            label: '账号管理人',
            prop: 'accountManager',
            width: 120
        },
        {
            label: '账号管理人状态',
            prop: 'accountManagerStatus',
            optionsKey: 'CRM_USER_INFO_STATUS',
            type: 'select',
            width: 120
        },
        {
            label: '90天内是否有更新',
            prop: 'hasUpdateIn90days',
            type: 'select',
            optionsKey: 'YES_OR_NO',
            disabled: true,
            width: 140
        },
        {
            label: '是否已复核',
            prop: 'isReviewed',
            type: 'select',
            optionsKey: 'YES_OR_NO',
            width: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 150
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: 150
        }
    ],
    actions: {
        list: []
    }
};
